import dateFormat from "dateformat";
import { sortBy, map, groupBy } from "lodash-es";
import { Transaction, TransactionType } from "@onmo/graphql/graphql";
import DailyStreakIcon from "../assets/icon/daily_streak/daily_streak_1x.webp";
import DailyStreakIcon2x from "../assets/icon/daily_streak/daily_streak_2x.webp";
import DailyStreakIcon3x from "../assets/icon/daily_streak/daily_streak_3x.webp";
import BonusCoins from "../assets/icon/daily_streak/bonus_coins_1x.webp";
import BonusCoins2x from "../assets/icon/daily_streak/bonus_coins_2x.webp";
import BonusCoins3x from "../assets/icon/daily_streak/bonus_coins_3x.webp";
import { getGameImage } from "./game";
import { ACHIEVEMENTS } from "../constants/achievement";

export const groupByDateReward = (rewards?: Transaction[]) => {
  const sortedTransactions = sortBy(rewards, (r) => {
    return new Date(r.date);
  }).reverse();

  const formatRewardsDate = map(sortedTransactions, (c) => {
    const now = new Date().getTime();
    const timeGap = (now - new Date(c.date).getTime()) / 86400000;
    const todayDate = new Date(now).getDate();
    const createdDate = new Date(c.date).getDate();
    if (timeGap < 1 && todayDate === createdDate) {
      return { ...c, timeline: "Today" };
    }
    const specificDate = dateFormat(c.date, "dd/mm/yyyy");
    return { ...c, timeline: specificDate };
  });

  const completedListGroupByCreatedDate = groupBy(
    formatRewardsDate,
    (o) => o.timeline,
  );

  return completedListGroupByCreatedDate;
};

export const getRewardImages = (reward?: Transaction) => {
  if (reward?.type === TransactionType.Manual)
    return {
      src: BonusCoins,
      src2x: BonusCoins2x,
      src3x: BonusCoins3x,
    };
  if (reward?.type === TransactionType.LoginReward)
    return {
      src: DailyStreakIcon,
      src2x: DailyStreakIcon2x,
      src3x: DailyStreakIcon3x,
    };
  if (reward?.type === TransactionType.AchievementReward)
    return getAchievementRewardImage(reward).achievementImage;
  if (
    reward?.type === TransactionType.Battle ||
    reward?.type === TransactionType.Challenge ||
    reward?.type === TransactionType.Tournament
  ) {
    const gameImage = getGameImage("small", reward?.game);
    return {
      src: gameImage?.webp,
      src2x: gameImage?.webp2x,
      src3x: gameImage?.webp3x,
    };
  } else return {};
};

export const getRewardTitle = (reward?: Transaction) => {
  if (reward?.type === TransactionType.Manual) return "Bonus";
  if (reward?.type === TransactionType.LoginReward) return "Daily streak";
  if (reward?.type === TransactionType.Battle) return "Battle";
  if (reward?.type === TransactionType.Challenge) return "Challenge";
  if (reward?.type === TransactionType.Tournament) return "Tournament";
  if (reward?.type === TransactionType.AchievementReward)
    return getAchievementRewardImage(reward)?.name;
  else return "unknown";
};

const getAchievementRewardImage = (reward: Transaction) => {
  const achievement = ACHIEVEMENTS.find((achievement) => achievement.id === reward.referenceId);
  return {
    achievementImage: achievement?.icons[1],
    name: achievement?.name.split("_")[1] || "Achievement Reward"
  };
};
